import { ReactNode } from "react";

export default function Card({ children }: { children: ReactNode }) {
    return <div className="rounded-2xl border border-rose-100 bg-white p-5 shadow-soft">{children}</div>;
}